let model = null

export const setSelectedModel = data => {
  model = data
}

export const getSelectedModel = () => {
  return model
}
